import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ViewController, Events } from 'ionic-angular';

@Component({
  selector: 'filepicker-button',
  templateUrl: 'filepicker.html',
  inputs: ['scope', 'allowMultiple']
})
export class FilePickerButton implements AfterViewInit {
  @ViewChild('hiddenCamera') cameraInput: ElementRef;
  @ViewChild('hiddenDoc') docInput: ElementRef;

  fileNames: any;
  fileTypes: any;
  fileData: any;

  allowMultiple: boolean = false;

  scope: any;

  constructor(public viewCtrl: ViewController,
    public events: Events) {
  }

  ngAfterViewInit() {
    let hiddenDoc = this.docInput.nativeElement as HTMLInputElement;

    var htmlElementDoc = <HTMLInputElement>document.getElementsByClassName('hiddenDoc')[document.getElementsByClassName('hiddenDoc').length - 1];
    hiddenDoc.onchange = () => {
      console.log(this.scope);
      if (hiddenDoc.files.length == 0) {
        return;
      }

      this.fileNames = [];
      this.fileTypes = [];
      for (let i = 0; i < htmlElementDoc.files.length; i++) {
        this.fileNames.push(htmlElementDoc.files.item(i).name);
        this.fileTypes.push(htmlElementDoc.files.item(i).type);
      }

      this.readFiles(Array.from(hiddenDoc.files)).then(allData => {
        console.log(allData);
        this.fileData = allData;
        if (!this.allowMultiple || Array.from(allData).length == 1) {
          this.events.publish(this.scope + ':filepicker',
            allData[0],
            htmlElementDoc.files.item(0).name,
            htmlElementDoc.files.item(0).type
          );
        } else {
          this.events.publish(this.scope + ':filepicker',
            allData,
            this.fileNames,
            this.fileTypes
          );
        }
        hiddenDoc.value = null;
      });
    };
  }

  fileToDataURL(file) {
    var reader = new FileReader()
    return new Promise(function (resolve, reject) {
      reader.onload = function (event: any) {
        resolve(event.target.result)
      }
      reader.onerror = function (event: any) {
        reject(event);
      }
      reader.readAsDataURL(file)
    })
  }

  readFiles(files) {
    return Promise.all(files.map(this.fileToDataURL));
  }

  pick() {
    let element: HTMLElement = document.getElementsByClassName('hiddenDoc')[document.getElementsByClassName('hiddenDoc').length - 1] as HTMLElement;
    element.click();
  }

  removeFile(name) {
    let index = this.fileNames.indexOf(name);;
    console.log(index);
    this.fileNames.splice(index, 1);
    this.fileTypes.splice(index, 1);
    this.fileData.splice(index, 1);

    if (this.fileNames.length == 1) {
      this.events.publish(this.scope + ':filepicker',
        this.fileData[0],
        this.fileNames[0],
        this.fileTypes[0]
      );
    } else {
      this.events.publish(this.scope + ':filepicker',
        this.fileData,
        this.fileNames,
        this.fileTypes
      );
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/filepicker/filepicker.ts